import React from 'react';
import { motion } from 'framer-motion';
import { BookOpen, Shield, AlertCircle, PenTool, Moon } from 'lucide-react';
export function SolutionSection() {
  const deliverables = [{
    icon: BookOpen,
    title: "Guía Digital 'El Fin de la Supermujer'",
    description: 'El mapa paso a paso para identificar tus fugas de energía.'
  }, {
    icon: Shield,
    title: "El Método del 'No Sagrado'",
    description: 'Scripts listos para usar para poner límites sin dar explicaciones.'
  }, {
    icon: AlertCircle,
    title: 'El Semáforo de la Sobrecarga',
    description: 'Una herramienta visual para detectar el colapso antes de que ocurra.'
  }, {
    icon: PenTool,
    title: 'Diario de Límites Críticos',
    description: 'Ejercicios guiados para auditar tu vida y eliminar tareas que no te corresponden.'
  }, {
    icon: Moon,
    title: 'Protocolo de Rescate de 11 PM',
    description: 'Qué hacer cuando la ansiedad no te deja dormir.'
  }];
  return <section className="space-y-16" data-id="element-86">
      <motion.div initial={{
      opacity: 0,
      scale: 0.98
    }} whileInView={{
      opacity: 1,
      scale: 1
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="bg-[#3D2B1F] text-[#FDF8F3] p-8 md:p-12 rounded-3xl shadow-xl relative overflow-hidden" data-id="element-87">
        <div className="absolute top-0 right-0 w-64 h-64 bg-[#C4704B] opacity-10 rounded-full blur-3xl transform translate-x-1/3 -translate-y-1/3" data-id="element-88" />

        <div className="relative z-10 text-center space-y-6" data-id="element-89">
          <h2 className="text-2xl md:text-3xl font-serif italic text-[#C4704B]" data-id="element-90">
            La solución no es organizarte mejor
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold" data-id="element-91">
            Es el{' '}
            <span className="text-white border-b-2 border-[#C4704B]" data-id="element-92">
              Desmontaje de la Identidad de Apoyo
            </span>
          </h3>
          <p className="text-[#FDF8F3]/90 text-lg leading-relaxed max-w-2xl mx-auto" data-id="element-93">
            Este método no te enseña a hacer más, te enseña a recuperar el valor
            de quién eres cuando no estás resolviendo la vida de nadie. Es un
            sistema diseñado para redistribuir la carga invisible y silenciar la
            ansiedad del desempeño que te obliga a ser perfecta.
          </p>
        </div>
      </motion.div>

      <div className="space-y-8" data-id="element-94">
        <div className="text-center" data-id="element-95">
          <h3 className="text-3xl font-bold text-[#3D2B1F] mb-2" data-id="element-96">
            Lo que recibes
          </h3>
          <p className="text-[#3D2B1F]/60" data-id="element-97">
            Herramientas prácticas para tu transformación
          </p>
        </div>

        <div className="space-y-4" data-id="element-98">
          {deliverables.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex items-center bg-white p-4 md:p-6 rounded-xl shadow-sm border border-[#3D2B1F]/5" data-id="element-99">
              <div className="bg-[#8B9E7E]/10 p-3 rounded-full text-[#8B9E7E] mr-4 md:mr-6 flex-shrink-0" data-id="element-100">
                <item.icon className="w-6 h-6" data-id="element-101" />
              </div>
              <div data-id="element-102">
                <h4 className="font-bold text-[#3D2B1F] text-lg" data-id="element-103">
                  {item.title}
                </h4>
                <p className="text-[#3D2B1F]/70 text-sm md:text-base" data-id="element-104">
                  {item.description}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}